import { useEffect, useState } from "react";
import ExcelJS from "exceljs"
import {saveAs} from "file-saver";

const CSV = ({runData,patternData,setData,orderData,print,setPrint,company,orderDataForSummary,selectedSheet}) => {
    const [orderDataArray,setOrderDataArray] = useState();
    const [runDataArray,setRunDataArray] = useState();
    const [patternDataArray,setPatternDataArray] = useState();
    const [setDataArray,setSetDataArray] = useState();
    const [orderDataForSummaryArray,setOrderDataForSummaryArray] = useState();

    useEffect(()=>{
        let visibleFields = runData ? Object.values(runData).filter((run)=>run?.visible) : [];
        setRunDataArray(visibleFields); 
    },[runData])
    
     useEffect(()=>{
        let visibleFields = setData ? Object.values(setData).filter((set)=>set?.visible) : [];
        setSetDataArray(visibleFields); 
    },[setData])

     useEffect(()=>{
        let visibleFields = patternData ? Object.values(patternData).filter((pattern)=>pattern?.visible) : [];
        setPatternDataArray(visibleFields); 
    },[patternData])

    useEffect(()=>{
        let visibleFields = orderData ? Object.values(orderData).filter((order)=>order?.visible) : [];
        setOrderDataArray(visibleFields); 
    },[orderData])

    useEffect(()=>{
        let visibleFields = orderDataForSummary ? Object.values(orderDataForSummary).filter((order)=>order?.visible) : [];
        setOrderDataForSummaryArray(visibleFields);
    },[orderDataForSummary])

    useEffect(()=>{
        (async()=>{if(print)
        {
            try
            {   
                let headerRows = [],patternRows = [],extraRowsStart = [],extraRowsEnd = [];
                let csvData = [[`${company?.business_name}`]];
                let n = Math.max(1,Math.floor(orderDataArray.length/2));
                for(let i=0;i<runDataArray.length;i=i+n)
                {
                    let arr = [];
                    for(let j=i;j<i+n;j++)
                    {
                        arr.push(j<runDataArray.length ?`${runDataArray[j]?.label}: ${runDataArray[j]?.value}`:"");
                        arr.push("");
                    }
                    csvData.push(arr);
                }
                csvData.push([]);

                for(let i=0;i<patternData?.pattern?.value?.length;i++)
                {
                    let str = "";
                    //adding pattern data
                    patternDataArray?.map((data,ind)=>{
                        str += `${data?.label}: ${data?.value[i]} ${(ind+1) == patternDataArray?.length && setDataArray?.length == 0 ? "" : "| "}` 
                    })
                    //adding set data
                    setDataArray?.map((data,ind)=>{
                        str += `${data?.label}: ${data?.value[i]} ${ind+1 == setDataArray?.length ? "" : "| "}`
                    })
                    patternRows.push(csvData.length);
                    csvData?.push([str]);


                    //adding orders label
                    let labelArray = []
                    orderDataArray?.map((data)=>{
                        labelArray?.push(`${data?.label}`);
                    })
                    headerRows.push(csvData.length);
                    csvData?.push(labelArray);


                    //adding order data each rows
                    for(let j=0;j<orderData?.width?.value[i].length;j++)
                    {
                        let row = [];
                        orderDataArray?.map((data)=>{
                            row?.push(`${Array.isArray(data?.value[i][j])?data?.value[i][j][0]:data?.value[i][j]}`)
                        })
                        csvData?.push(row);
                        if(Array.isArray(orderData?.order_no?.value[i][j]))
                        {
                            extraRowsStart.push(csvData?.length);
                            orderData?.order_no?.value[i][j]?.slice(1,)?.forEach((_,k)=>{
                                let newRow = [];
                                orderDataArray?.map((data)=>{
                                    newRow?.push(`${Array.isArray(data?.value[i][j])?data?.value[i][j][k+1]:""}`)
                                })
                                csvData?.push(newRow);
                            })
                            extraRowsEnd?.push(csvData?.length);
                        }
                    }

                    csvData?.push([]);
                }

                console.log("csv",csvData)
                console.log(extraRowsStart,extraRowsEnd);

                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet(`${runData?.jc_no?.value || "JobCard"}`);

                csvData?.forEach((rowData,index)=>{
                    const row =  worksheet.addRow(rowData);

                    if(index>0 && index<(patternRows[0]-1))
                    {
                        row.eachCell({includeEmpty:true},(_,ind) => {
                            worksheet.mergeCells(index+1,2*(ind-1)+1,index+1,2*(ind-1)+2)
                        })
                    }

                    if(headerRows.includes(index) || index == 0)
                    {
                        row.eachCell({includeEmpty:true},(cell)=>{
                            cell.fill = {
                                type: "pattern",
                                pattern: "solid",
                                fgColor: {
                                    argb: "f3f4f6",
                                }
                            }
                            cell.font = { 
                                bold:true
                            }
                            if(index == 0)
                            {
                                cell.alignment = {
                                    horizontal: "center",
                                }
                                worksheet.mergeCells(1,1,1,orderDataArray?.length);
                            }
                        })
                    }
                    if(patternRows.includes(index))
                    {
                        row.eachCell({includeEmpty:true},(cell)=>{
                            cell.fill ={
                                type: "pattern",
                                pattern : "solid",
                                fgColor : {argb: "FDEEEA"} 
                            }
                            cell.font = {
                                bold: true,
                            }
                            worksheet.mergeCells(index+1,1,index+1,orderDataArray?.length);
                        })
                    }
                })


                worksheet.eachRow({includeEmpty:true},(row,ind)=>{
                    if(extraRowsStart?.includes(ind-1)){
                        let s = extraRowsStart.shift(),e = extraRowsEnd.shift();
                        row.eachCell({includeEmpty:true},(cell,i)=>{
                            if(cell?.value == ""){
                                worksheet.mergeCells(s,i,e,i);
                                cell.alignment = {vertical:"middle"}
                            }
                        })
                    }
                })

                let patternDataRowLength = worksheet.getCell(patternRows[0]+1,1).value.toString().length;
                worksheet.columns.forEach((column,ind)=>{
                    let maxLength = 10;
                    
                    column.eachCell((cell,index)=>{
                        if(index>patternRows[0] && !(headerRows.includes(index) || index == 0 || patternRows.includes(index)))
                            maxLength = Math.max(maxLength,cell?.value ? cell.value.length : 0);
                    })

                    //added this condition as pattern row was getting hide due to less no of columns
                    if(ind+1 == orderDataArray?.length)
                        column.width = Math.max(patternDataRowLength,maxLength+2);
                    else{
                        column.width = maxLength + 2;
                        patternDataRowLength = patternDataRowLength - column.width;
                    }
                })

                const worksheet2 = workbook.addWorksheet("Order Summary");
                let csvData2 = [[`${company?.business_name}`]];

                let arr2 = [];
                for(let i = 0;i<orderDataForSummaryArray.length;i++)
                {
                    arr2.push("");
                }
                csvData2.push(arr2);

                let headers2 = [];
                orderDataForSummaryArray?.forEach((data)=>{
                    headers2.push(data?.label);
                })
                csvData2.push(headers2);

                orderDataForSummary?.order_no?.value?.forEach((_,i)=>{
                    let data2 = [];
                    orderDataForSummaryArray?.forEach((data)=>{
                        data2?.push(data?.value[i]);
                    })
                    csvData2.push(data2);
                })

                csvData2.forEach((rowData,index)=>{
                    const row = worksheet2.addRow(rowData);

                    if(index == 2 || index == 0)
                    {
                        row.eachCell((cell)=>{
                            cell.fill = {
                                type: "pattern",
                                pattern: "solid",
                                fgColor: {
                                    argb: "f3f4f6",
                                }
                            }
                            cell.font = { 
                                bold:true
                            }
                            if(index == 0)
                            {
                                cell.alignment = {
                                    horizontal: "center",
                                }
                                worksheet2.mergeCells(1,1,1,orderDataForSummaryArray?.length);
                            }
                        })
                    }
                })

                worksheet2.columns.forEach((column)=>{
                    let maxLength = 10;
                    column.eachCell((cell,index)=>{
                        if(index != 3 || index != 1)
                            maxLength = Math.max(maxLength,cell?.value ? cell?.value?.toString()?.length : 0);
                    })
                    column.width = maxLength+2;
                })

                const buffer = await workbook.xlsx.writeBuffer();
                saveAs(new Blob([buffer]),`${runData?.jc_no?.value || "JobCard"}.xlsx`)
                setPrint(false);
            }
            catch(e)
            {
                console.log(e);
            }
        }})()
    },[print])

    return (
        orderDataArray && patternDataArray && setDataArray && runDataArray && company?<table>
            <thead>
                <tr>
                    <th colSpan={selectedSheet == "sheet_1" ? orderDataArray.length : orderDataForSummaryArray.length}>{company?.business_name}</th>
                </tr>
            </thead>
            
            {
                selectedSheet == "sheet_1" 
                ?<tbody>
                    <tr>
                        {orderDataArray.map(()=>(<td></td>))}
                    </tr>
                    {
                        (()=>{
                            let n = Math.max(1,Math.floor(orderDataArray.length/2));
                            let arr = [];
                            for(let i = 0; i < Math.ceil(runDataArray.length/n); i++){
                                arr.push(i);
                            }
                            return arr.map((i)=>{
                                const slicedArray = runDataArray.slice(i*n,(i+1)*n);
                                return (<tr>
                                    {slicedArray?.map((data)=>(<td colSpan={2}>{`${data.label} : ${data.value}`}</td>))}
                                    {(slicedArray?.length < n) && Array.from({length:n-slicedArray?.length}).map(()=>(<td colSpan={2}></td>))}
                                </tr>)
                            })
                            
                        })()
                    }
                    <tr>
                        {orderDataArray.map(()=>(<td></td>))}
                    </tr>
                    {
                        patternData?.pattern?.value?.map((pattern,i)=>{
                            return (
                                <>
                                    <tr className="patternSetData">
                                        <td colSpan={orderDataArray.length}>
                                            {
                                                patternDataArray?.map((data,l)=>(
                                                    <span>{`${data?.label}: ${data?.value[i]} ${setDataArray.length == 0 && l+1 == patternDataArray.length ? "" :"|"} `}</span>
                                                ))
                                            }
                                            {
                                                setDataArray?.map((data,j)=>(
                                                    <span>{`${data?.label}: ${data?.value[i]} ${j+1!=setDataArray.length?'| ':""}`}</span>
                                                ))

                                            }
                                        </td>
                                    </tr>
                                    <tr className="orderDataHeader">
                                        {orderDataArray?.map((data)=>(
                                            <td>{data.label}</td>
                                        ))}
                                    </tr>
                                    {orderData?.width?.value[i]?.map((width,k)=>{
                                        if(Array.isArray(orderData?.order_no?.value[i][k]))
                                        {
                                            return (
                                                <>
                                                    <tr>
                                                        {orderDataArray?.map((data)=>(
                                                            Array.isArray(data?.value[i][k])?
                                                            <td>
                                                                {data?.value[i][k][0]}
                                                            </td>
                                                            :<td rowSpan={orderData?.order_no?.value[i][k]?.length}>
                                                                {data?.value[i][k]}
                                                            </td>
                                                        ))}
                                                    </tr>
                                                    {orderData?.order_no?.value[i][k].slice(1,)?.map((data,l)=>(<tr>
                                                        {orderDataArray?.map((data)=>(
                                                            Array.isArray(data?.value[i][k])
                                                            ?<td>{data?.value[i][k][l+1]}</td>
                                                            :<></>
                                                        ))}
                                                    </tr>))}
                                                </>
                                            )
                                        }
                                        else{
                                            return(<tr>
                                                {orderDataArray?.map((data)=>(
                                                    <td>{data?.value[i][k]}</td>
                                                ))}
                                            </tr>)
                                        }
                                    })}
                                    <tr>
                                        {orderDataArray.map(()=>(<td></td>))}
                                    </tr>
                                </>
                            )
                        })
                    }
                </tbody>
                :<tbody>
                    <tr>
                        {orderDataForSummaryArray?.map(()=>(
                            <td></td>
                        ))}
                    </tr>
                    <tr className="orderDataHeader">
                        {orderDataForSummaryArray?.map((data)=>(
                            <td>{data.label}</td>
                        ))}
                    </tr>
                    {
                        orderDataForSummary?.order_no?.value?.map((_,i)=>{
                            return <tr>
                                {orderDataForSummaryArray?.map((data)=>(
                                    <td>{data?.value[i]}</td>
                                ))}
                            </tr>
                        })
                    }
                </tbody>
            }
        </table>
        :<></>
    );
}

export default CSV;